exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\npath[data-v-6884076f] {\n  fill: none;\n  stroke-width: 3;\n}\n.hover > .container path[data-v-6884076f] {\n  stroke: #ea6e00;\n}\n", ""]);

// exports
